import {
  BarChart3,
  FileSearch,
  HandHeart,
  Headset,
  ShieldCheck,
  UserRoundCheck
} from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { whyChooseUs } from "../../data/homeData";

const iconMap = {
  user: UserRoundCheck,
  chart: BarChart3,
  shield: ShieldCheck,
  support: Headset,
  docs: FileSearch,
  mentorship: HandHeart
};

function WhyChooseSection() {
  return (
    <MotionSection id="why-us" className="relative py-20 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Why Choose NextEra"
          title="Built for Outcomes, Backed by Human Mentorship"
          description="We combine strategy, transparency, and personal support so students and parents feel informed and confident through every milestone."
        />

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:gap-8">
          {whyChooseUs.map((item, index) => {
            const Icon = iconMap[item.icon];
            const colors = [
              "bg-blue-500 text-blue-500",
              "bg-emerald-500 text-emerald-500",
              "bg-amber-500 text-amber-500",
              "bg-purple-500 text-purple-500",
              "bg-rose-500 text-rose-500",
              "bg-cyan-500 text-cyan-500"
            ];
            const accentClass = colors[index % colors.length];
            const [bgClass, textClass] = accentClass.split(' ');

            return (
              <article
                key={item.title}
                className="group relative card-elevated overflow-hidden rounded-[1.25rem] p-6 lg:p-8 flex gap-5 md:items-center"
              >
                <div className={`absolute left-0 top-0 bottom-0 w-1.5 transition-all duration-300 group-hover:w-2 ${bgClass}`} />
                
                <div className={`shrink-0 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-50 border border-slate-100 shadow-sm transition-transform group-hover:scale-110 group-hover:shadow-md ${textClass}`}>
                  <Icon className="h-6 w-6" aria-hidden="true" />
                </div>
                
                <div>
                  <h3 className="text-xl font-bold leading-tight text-midnight-navy">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-text/75">{item.description}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </MotionSection>
  );
}

export default WhyChooseSection;
